module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pack",
    class: _vm.holderClass,
    style: (_vm.holderWithPx),
    attrs: {
      "title": ""
    },
    on: {
      "dblclick": function($event) {
        $event.preventDefault();
        return _vm.dblClick.apply(null, arguments)
      },
      "click": function($event) {
        $event.preventDefault();
        return _vm.click($event, 'pack')
      }
    }
  }, [_c('div', {
    staticClass: "front side",
    style: (_vm.front),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.click($event, 'front')
      },
      "mousedown": function($event) {
        return _vm.mousedown($event, 'front')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right side",
    style: (_vm.right),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.click($event, 'right')
      },
      "mousedown": function($event) {
        return _vm.mousedown($event, 'right')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "top side",
    style: (_vm.top),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.click($event, 'top')
      },
      "mousedown": function($event) {
        return _vm.mousedown($event, 'top')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bottom side",
    style: (_vm.bottom),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.click($event, 'bottom')
      },
      "mousedown": function($event) {
        return _vm.mousedown($event, 'bottom')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "left side",
    style: (_vm.left),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.click($event, 'left')
      },
      "mousedown": function($event) {
        return _vm.mousedown($event, 'left')
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "back side",
    style: (_vm.back),
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.click($event, 'back')
      },
      "mousedown": function($event) {
        return _vm.mousedown($event, 'back')
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2bd446db","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pack.vue
// module id = 235
// module chunks = 1